import makeBox from "./box";
var Box = makeBox("div");
export default Box;
